// extracted by mini-css-extract-plugin
export var activityContainer = "_j8-0";
export var typingIndicatorContainer = "_j8-1";
export var typingIndicatorDot = "_j8-2";
export var wave = "_j8-3";